var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6705C0.109534 4.69464 5.0234 -0.0716682 11 0.000815879C16.9766 -0.0716682 21.8905 4.69464 22 10.6705C22 20.0002 11 28 11 28C11 28 0 20.0002 0 10.6705ZM6 11.0005C6 13.7618 8.23858 16.0003 11 16.0003C13.7614 16.0003 16 13.7618 16 11.0005C16 8.23915 13.7614 6.00064 11 6.00064C8.23858 6.00064 6 8.23915 6 11.0005Z",
    fill: "#3366FF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6705C0.109534 4.69464 5.0234 -0.0716682 11 0.000815879C16.9766 -0.0716682 21.8905 4.69464 22 10.6705C22 20.0002 11 28 11 28C11 28 0 20.0002 0 10.6705ZM6 11.0005C6 13.7618 8.23858 16.0003 11 16.0003C13.7614 16.0003 16 13.7618 16 11.0005C16 8.23915 13.7614 6.00064 11 6.00064C8.23858 6.00064 6 8.23915 6 11.0005Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.df91bbd39b8452588d8116f88e02fe10.svg";
export { ForwardRef as ReactComponent };